


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getOrderDetailPage } from '@/api/order'

@Component({
  name: 'TabChange'
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics: any
  @Prop({ default: '' }) defaultActivity: any
  private activeIndex: number = this.defaultActivity || 0

  @Watch('defaultActivity')
  private onChange(val) {
    this.activeIndex = Number(val)
  }

  get changedOrderList() {
    return [
      {
        label: '待颁发',
        value: 3,
        num: this.orderStatics.notPass
      },
      {
        label: '已颁发',
        value: 4,
        num: this.orderStatics.passAll
      },
      {
        label: '待上传',
        value: 1,
        num: this.orderStatics.toBePasss
      },
      {
        label: '已上传',
        value: 2,
        num: this.orderStatics.pass
      }
    ]
  }

  private tabChange(activeIndex) {
    this.activeIndex = activeIndex
    this.$emit('tabChange', activeIndex)
  }
}
